export const ERRORS = {
  useLazyQuery:
    "useInfiniteLazyQuery: The 'useLazyQuery' parameter must be a function.",
  entityKey:
    "useInfiniteLazyQuery: The 'entityKey' parameter must be a string.",
};
